// extracted by mini-css-extract-plugin
export default {"campaigns":"Campaigns_campaigns__6VAQb","createForm":"Campaigns_createForm__xDuXa App_paper__8CPy4","results":"Campaigns_results__vATHy App_paper__8CPy4"};